import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {RouterModule} from "@angular/router";
import {HeaderComponent} from "../layout/header/header.component";
import {FooterComponent} from "../layout/footer/footer.component";
import {FeaturesComponent} from "./features.component";
import { DialogModule } from "primeng/dialog";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {ComponentsModule} from "./components/components.module";
import {CarouselModule} from "primeng/carousel";
import {TagModule} from "primeng/tag";
import {ButtonModule} from "primeng/button";
import {MenuModule} from "primeng/menu";
import {BadgeModule} from "primeng/badge";
import {GalleriaModule} from "primeng/galleria";
import { routing } from "./features.routing";
import {CartComponent} from "./cart/cart.component";
import {ItemComponent} from "./cart/item/item.component";
import {CheckoutComponent} from "./cart/checkout/checkout.component";
import {PaymentComponent} from "./cart/payment/payment.component";
import {ProfileModule} from "./profile/profile.module";
import {ChipModule} from "primeng/chip";
import {ChipsModule} from "primeng/chips";
import {FieldsetModule} from "primeng/fieldset";
import {SidebarModule} from "primeng/sidebar";
import {AccordionModule} from "primeng/accordion";
import {ProductsModule} from "./product/products.module";
import {ProductsComponent} from "./product/products.component";
import {CoreModule} from "../core/core.module";
import {LoginComponent} from "./components/auth/login/login.component";
import {SignupComponent} from "./components/auth/signup/signup.component";
import {RegisterComponent} from "./components/auth/register/register.component";
import {OffersComponent} from "./components/offers/offers.component";
import {MomentModule} from "ngx-moment";
import {ReachUsComponent} from "./components/policy/reach-us/reach-us.component";
import {TermsComponent} from "./components/policy/terms/terms.component";
import {PrivacyPolicyComponent} from "./components/policy/privacy-policy/privacy-policy.component";
import {ReturnPolicyComponent} from "./components/policy/return-policy/return-policy.component";
import {DisclaimerPolicyComponent} from "./components/policy/disclaimer-policy/disclaimer-policy.component";
import {OrderStatusComponent} from "./components/order-status/order-status.component";
import {PolicyComponent} from "./components/policy/policy.component";
import {CancelOrderComponent} from "./components/cancel-order/cancel-order.component";
import {ProgressSpinnerModule} from "primeng/progressspinner";
import {ProgressBarModule} from "primeng/progressbar";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {HomeComponent} from "./home/home.component";

@NgModule({
  declarations: [
    HeaderComponent,
    FooterComponent,
    HomeComponent,
    FeaturesComponent,
    ProductsComponent,
    CartComponent,
    ItemComponent,
    CheckoutComponent,
    PaymentComponent,
    LoginComponent,
    SignupComponent,
    RegisterComponent,
    OffersComponent,
    ReachUsComponent,
    TermsComponent,
    PrivacyPolicyComponent,
    ReturnPolicyComponent,
    DisclaimerPolicyComponent,
    OrderStatusComponent,
    PolicyComponent,
    CancelOrderComponent,
  ],
  exports: [
    HeaderComponent,
    FooterComponent
  ],
  imports: [
    BrowserAnimationsModule,
    CommonModule,
    routing,
    RouterModule,
    DialogModule,
    FormsModule,
    ComponentsModule,
    CarouselModule,
    TagModule,
    ButtonModule,
    MenuModule,
    BadgeModule,
    GalleriaModule,
    ProfileModule,
    ChipModule,
    ChipsModule,
    FieldsetModule,
    SidebarModule,
    AccordionModule,
    ProductsModule,
    CoreModule,
    MomentModule,
    ProgressSpinnerModule,
    ReactiveFormsModule,
    ProgressBarModule,
  ]
})
export class FeaturesModule { }
